import {
    HiArrowPath, HiChatBubbleLeft, HiCheckCircle, HiOutlineCpuChip, HiPencilSquare, HiUserGroup, HiFlag,
} from "react-icons/hi2";

// Fork of candidate/timelineHelpers.js -- kept separate because Lead's TimelineKind vocabulary
// (Created/Initialized/StatusChange/Note/ManualEntry/Qualified/ConversionProposed/HandedToHuman)
// and LeadStatus vocabulary don't overlap with Candidate's i18next keys.

const KIND_LABELS = {
    created: "Utworzono", initialized: "Rozpoczęto rozmowę", statuschange: "Zmiana statusu",
    note: "Notatka", manualentry: "Wpis ręczny", qualified: "Zakwalifikowano",
    conversionproposed: "Zaproponowano konwersję", handedtohuman: "Przekazano do człowieka",
};

const KIND_COLOR = {
    created: "gray", initialized: "gray", statuschange: "orange", note: "gray",
    manualentry: "yellow", qualified: "purple", conversionproposed: "teal", handedtohuman: "blue",
};

const STATUS_LABELS = {
    New: "Nowy", ContactAttempted: "Próba kontaktu", Contacted: "Skontaktowano", Conversation: "Rozmowa",
    Qualifying: "Kwalifikacja", Qualified: "Zakwalifikowany", Interested: "Zainteresowany",
    ConversionProposed: "Zaproponowano konwersję", Converted: "Skonwertowany", NotInterested: "Niezainteresowany",
    NoResponse: "Brak odpowiedzi", Disqualified: "Zdyskwalifikowany", HandedToHuman: "Przekazano do człowieka",
};

export const getLeadTimelineIcon = (kind) => {
    const k = (kind || '').toLowerCase();
    if (k === 'note') return <HiChatBubbleLeft />;
    if (k === 'statuschange') return <HiArrowPath />;
    if (k === 'initialized') return <HiOutlineCpuChip />;
    if (k === 'created') return <HiCheckCircle />;
    if (k === 'manualentry') return <HiPencilSquare />;
    if (k === 'qualified') return <HiCheckCircle />;
    if (k === 'conversionproposed' || k === 'handedtohuman') return <HiUserGroup />;
    return <HiFlag />;
};

export const getLeadTimelineBadgeProps = (kind) => {
    const k = (kind || '').toLowerCase();
    return { label: KIND_LABELS[k] ?? kind, colorPalette: KIND_COLOR[k] ?? "gray" };
};

export const parseLeadMetadata = (metadata) => {
    if (!metadata) return null;
    if (typeof metadata === 'object') return metadata;
    try { return JSON.parse(metadata); } catch { return null; }
};

export const getLeadTimelineEventDescription = (event) => {
    const meta = parseLeadMetadata(event.metadata);
    const k = (event.kind || '').toLowerCase();
    if (k === 'statuschange') {
        const to = meta?.newStatus ?? meta?.NewStatus;
        const label = STATUS_LABELS[to] ?? to;
        return label ? `Status zmieniony na: ${label}` : null;
    }
    if (k === 'note') return meta?.Content ?? meta?.content ?? null;
    if (k === 'initialized') return "Rozpoczęto pierwszą rozmowę z leadem";
    if (k === 'created') return "Lead utworzony";
    if (k === 'manualentry') return meta?.description ?? null;
    return null;
};
